import { render, staticRenderFns } from "./login_code.vue?vue&type=template&id=11bcc19f&scoped=true"
import script from "./login_code.vue?vue&type=script&lang=js"
export * from "./login_code.vue?vue&type=script&lang=js"
import style0 from "./login_code.vue?vue&type=style&index=0&id=11bcc19f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11bcc19f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/riverlei/project/java/bgyy-project/front-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11bcc19f')) {
      api.createRecord('11bcc19f', component.options)
    } else {
      api.reload('11bcc19f', component.options)
    }
    module.hot.accept("./login_code.vue?vue&type=template&id=11bcc19f&scoped=true", function () {
      api.rerender('11bcc19f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/login/login_code.vue"
export default component.exports